import React, { useEffect, useMemo, useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link, useLocation } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import PredefinedDateRanges from "../../../core/common/datePicker";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import {
  createPolicy,
  updatePolicy,
  deletePolicy,
} from "../../../core/data/redux/policy/policyAction";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import {
  fetchAllPolicies,
  fetchPolicyById,
} from "../../../core/data/redux/policy/policyAction";
import DeleteModal1 from "../../../core/modals/deleteModal1";
import { formatDate } from "../../../core/utils/configFormatters";
import {
  exportToCSV,
  exportToExcel,
} from "../../../core/common/GlobalFunctions/exportTableData";
import { filterData } from "../../../core/common/GlobalFunctions/tableFilters";
import { Drawer, message } from "antd";
import { status } from "../../../core/common/selectoption/selectoption";
import {
  FetchAllPolicyCategory,
  createPolicyCategory,
  UpdatePolicyCategory,
  FetchPolicyCategoryById,
  DeletePolicyCategory,
} from "../../../core/data/redux/policyCategory/policyCategoryAction";
import { useAppConfig } from "../../../customhooks/useAppConfig";
import { decryptData } from "../../../core/utils/encryptUtils";

const PolicyCategory = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [isModalOpen, setIsModalOpen] = useState(false); //
  const [selectedStatus, setSelectedStatus] = useState("active");
  const [selectedSort, setSelectedSort] = useState<any>("");
  const [tableKey, setTableKey] = useState(0);
  const { user } = useSelector((state: any) => state.auth);
  const { departments } = useSelector((state: any) => state.department);
  const { policycategory, loadingStates } = useSelector((state: any) => state.policycategory);
  const [modalType, setModalType] = useState<'edit' | 'create' | ''>('');
  const isLoading = modalType === "edit" ? loadingStates.update : loadingStates.create;
  const departementData = departments ? departments : [];
  const [isEditing, setIsEditing] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [selectedRowData, setSelectedRowData] = useState<any>();
  const policyCategoryId = selectedRowData?.Id;
  const [isDeleteModalVisible, setIsDeleteModalVisible] =
    useState<boolean>(false);

  const encryptedPermissions = localStorage.getItem('currentPermissions');
  const permissions: string[] = Array.isArray(decryptData(encryptedPermissions || '')) ? decryptData(encryptedPermissions || '') : [];

  const canAdd =
    permissions.includes("Add") || permissions.includes("AllowAll");
  const canView =
    permissions.includes("View") || permissions.includes("AllowAll");
  const canEdit =
    permissions.includes("Edit") || permissions.includes("AllowAll");
  const canDelete =
    permissions.includes("Delete") || permissions.includes("AllowAll");
  const canExport =
    permissions.includes("Export") || permissions.includes("AllowAll");

  const handleEditPolicy = (record: any): void => {
    setIsEditing(true);
    setSelectedRowData(record);

    setFormData({
      Name: record.Name || "",
      Description: record.Description || "",
      CategoryType: record.CategoryType || "",
      Status: record.Status || "active",
      ModifiedBy: user.UserId || null,
    });
  };

  const [formData, setFormData] = useState<any>({
    Name: "",
    CategoryType: "",
    Description: "",
    Status: "active",
    CreatedBy: isEditing ? "" : user.UserId,
    ModifiedBy: isEditing ? user.UserId : "",
  });

  const [errors, setErrors] = useState<any>({
    Name: "",
    CategoryType: "",
    Description: "",
    Status: "active",
  });

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleDeletePolicy = async (policyCategoryId: any) => {
    try {
      const resp = await dispatch(DeletePolicyCategory(policyCategoryId));
      if (resp.meta.requestStatus === "fulfilled") {
        setIsDeleteModalVisible(false);
        message.success(resp.payload.message);
        await dispatch(FetchAllPolicyCategory());
        setTableKey((prevKey) => prevKey + 1);
      } else {
        setIsDeleteModalVisible(false);
        message.error(resp.payload.message);
      }
    } catch (error: any) {
      message.error("error is ", error);
    }
  };
  const resetForm = () => {
    setFormData({
      Name: "",
      CategoryType: "",
      Description: "",
      Status: "active",
    });
    setErrors({
      Name: "",
      CategoryType: "",
      Description: "",
      Status: "active",
    });
  };

  const showModal = (type: "edit" | "create") => {
    setModalType(type);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setModalType("");
    resetForm();
  };

  const validateForm = () => {
    const newErrors: any = {};

    if (!formData.Name) {
      newErrors.Name = "Policy name is required.";
    }
    if (!formData.CategoryType) {
      newErrors.CategoryType = "Category Type is required.";
    }

    if (!formData.Status) {
      newErrors.Status = "Status is required.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onsubmit = async (e: any) => {
    try {
      e.preventDefault();
      const isValid = validateForm();
      if (!isValid) return;

      const payload = {
        Name: formData.Name,
        CategoryType: formData.CategoryType,
        Description: formData.Description,
        Status: formData.Status,
        ...(modalType === "edit"
          ? { modifiedBy: user.UserId }
          : { createdBy: user.UserId }),
      };

      if (modalType === "edit") {
        const resp = await dispatch(
          UpdatePolicyCategory({ Id: policyCategoryId, data: payload })
        );
        if (resp.meta.requestStatus === "fulfilled") {
          message.success(resp.payload.message);
          await dispatch(FetchAllPolicyCategory());
          resetForm();
          setTableKey((prevKey) => prevKey + 1);
        }
      } else {
        const resp = await dispatch(createPolicyCategory(payload));
        if (resp.meta.requestStatus === "fulfilled") {
          message.success(resp.payload.message);
          await dispatch(FetchAllPolicyCategory());
        } else {
          message.warning(resp.payload.message);
        }
        resetForm();
        setTableKey((prevKey) => prevKey + 1);
      }
      handleCancel();
    } catch (error: any) {
      message.error("Error submitting form:", error);
    }
  };

  ///fetching the data
  useEffect(() => {
    dispatch(FetchAllPolicyCategory());
  }, []);

  const data = policycategory ? policycategory : [];

  const exportPolicyCategory = data?.map((category: any) => ({
    CategoryID: category.Id,
    CategoryName: category.Name || "N/A",
    CategoryType: category.CategoryType || "N/A",
    Description: category.Description || "N/A",
    Status: category.Status ? category.Status.charAt(0).toUpperCase() + category.Status.slice(1) : "N/A",
    CreatedBy: category.CreatedBy || "N/A",
    CreatedAt: category.CreatedAt ? new Date(category.CreatedAt).toLocaleDateString("en-IN") : "N/A",
    ModifiedBy: category.ModifiedBy || "N/A",
    ModifiedAt: category.ModifiedAt ? new Date(category.ModifiedAt).toLocaleDateString("en-IN") : "N/A",
  }));


  const filteredData = useMemo(() => {
    return filterData(
      policycategory || [],
      { Status: selectedStatus },
      "CreatedAt",
      "CreatedAt",
      selectedSort
    );
  }, [policycategory, selectedStatus, selectedSort]);

  useEffect(() => {
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedStatus, selectedSort, policycategory]);

  const config = useAppConfig();
  if (!config) return null;

  const columns = [
    {
      title: "Name",
      dataIndex: "Name",
      render: (text: String, record: any) => (
        <h6 className="fw-medium fs-14 text-dark">{text}</h6>
      ),
      sorter: (a: any, b: any) => a.Name.length - b.Name.length,
    },
    {
      title: "Policy Type",
      dataIndex: "CategoryType",
      sorter: (a: any, b: any) => a.CategoryType.length - b.CategoryType.length,
    },
    {
      title: "Description",
      dataIndex: "Description",
      sorter: (a: any, b: any) => a.Description?.length - b.Description?.length,
      render: (text: string) => (
        <span>{text?.trim() ? text : "No Description"}</span>
      ),
    },

    {
      title: "Created Date",
      dataIndex: "CreatedAt",
      render: (text: string) => formatDate(text, config),
      sorter: (a: any, b: any) => {
        const dateA = new Date(a.CreatedAt);
        const dateB = new Date(b.CreatedAt);
        return dateA.getTime() - dateB.getTime();
      },
    },
    {
      title: "Status",
      dataIndex: "Status",
      render: (text: string, record: any) => (
        <span
          className={`badge ${text === "active" ? "badge-success" : "badge-danger"
            } d-inline-flex align-items-center badge-xs`}
        >
          <i className="ti ti-point-filled me-1" />
          {text ? text.charAt(0).toUpperCase() + text.slice(1) : ""}

        </span>
      ),
      sorter: (a: any, b: any) => a.Status.length - b.Status.length,
    },
    {
      title: "Action",
      dataIndex: "actions",
      render: (text: string, record: any) => (
        <div className="action-icon d-inline-flex">

          {/* Edit Button */}
          <button
            className="me-2"
            onClick={() => {
              if (!canEdit) return;
              showModal("edit");
              handleEditPolicy(record);
            }}
            disabled={!canEdit}
            style={{
              cursor: canEdit ? "pointer" : "not-allowed",
              opacity: canEdit ? 1 : 0.5,
            }}
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={!canEdit ? "Permission Denied" : "Edit Policy"}
          >
            <i className="ti ti-edit" />
          </button>

          {/* Delete Button */}
          <button
            onClick={() => {
              if (!canDelete || record.Status === "inactive") return;
              setSelectedRowData(record);
              setIsDeleteModalVisible(true);
            }}
            disabled={!canDelete || record.Status === "inactive"}
            style={{
              cursor:
                !canDelete || record.Status === "inactive"
                  ? "not-allowed"
                  : "pointer",
              opacity:
                !canDelete || record.Status === "inactive"
                  ? 0.5
                  : 1,
            }}
            className="btn-icon"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title={
              !canDelete
                ? "Permission Denied"
                : record.Status === "inactive"
                  ? "Policy is inactive"
                  : "Delete Policy"
            }
          >
            <i className="ti ti-trash" />
          </button>

        </div>
      ),
    },
  ];
  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Policy Category</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="index.html">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  {/* <li className="breadcrumb-item">HR</li> */}
                  <li className="breadcrumb-item active" aria-current="page">
                    Policy Category
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              {canExport && (
                <div className="me-2 mb-2">
                  <div className="dropdown">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      <i className="ti ti-file-export me-1" />
                      Export
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li>
                        <button
                          onClick={() => exportToCSV(exportPolicyCategory, "policyCategory_data")}
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-pdf me-1" />
                          Export as CSV
                        </button>
                      </li>
                      <li>
                        <button
                          onClick={() =>
                            exportToExcel(exportPolicyCategory, "policyCategory_data")
                          }
                          className="dropdown-item rounded-1"
                        >
                          <i className="ti ti-file-type-xls me-1" />
                          Export as Excel{" "}
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>
              )}
              {canAdd && (
                <div className="mb-2">
                  <button
                    className="btn btn-primary d-flex align-items-center"
                    onClick={() => showModal("create")}
                  >
                    <i className="ti ti-circle-plus me-2" />
                    Add Policy Category
                  </button>
                </div>
              )}
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          {/* Policy list */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <h5>Policy Category List</h5>
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-3">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedStatus
                      ? selectedStatus.charAt(0).toUpperCase() +
                      selectedStatus.slice(1)
                      : "Select Status"}
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("active")}
                        className="dropdown-item rounded-1"
                      >
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedStatus("inactive")}
                        className="dropdown-item rounded-1"
                      >
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-sm btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    {selectedSort
                      ? `Sort By : ${selectedSort}`
                      : "Sort By : Last 7 Days"}
                  </Link>
                  <ul className="dropdown-menu dropdown-menu-end p-3">
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Recently Added")}
                        className="dropdown-item rounded-1"
                      >
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Ascending")}
                        className="dropdown-item rounded-1"
                      >
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Descending")}
                        className="dropdown-item rounded-1"
                      >
                        Descending
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last Month")}
                        className="dropdown-item rounded-1"
                      >
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="#"
                        onClick={() => setSelectedSort("Last 7 Days")}
                        className="dropdown-item rounded-1"
                      >
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <Table
                key={tableKey}
                dataSource={filteredData}
                columns={columns}
                Selection={true}
              />
            </div>
          </div>
          {/* /Policylist list */}
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add Policy */}
      <Drawer
        title={
          modalType === "edit" ? "Edit Policy Category" : "Add Policy Category"
        }
        placement="right"
        width={560}
        onClose={handleCancel}
        visible={isModalVisible}
        style={{ marginTop: 50, paddingBottom: 50 }}
      >
        <form>
          <div className="modal-body pb-0">
            <div className="row">
              {/* 1. Policy Name */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Policy Name <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className={`form-control ${errors.Name ? "is-invalid" : ""}`}
                  name="Name"
                  value={formData.Name}
                  onChange={handleChange}
                />
                {errors.Name && <div className="invalid-feedback">{errors.Name}</div>}
              </div>

              {/* 2. Category Type with 5 radio buttons */}
              <div className="col-md-12 mb-3">
                <label className="form-label d-block">
                  Category Type <span className="text-danger">*</span>
                </label>
                <div className="d-flex flex-row gap-1">
                  {[
                    "Department",
                    "Project",
                    "Team",
                    "Employee",
                    "Male",
                    "Female",
                  ].map((type) => (
                    <div className="form-check" key={type}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="CategoryType"
                        value={type}
                        checked={formData.CategoryType === type}
                        onChange={handleChange}
                        id={`category-${type}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`category-${type}`}
                      >
                        {type}
                      </label>
                    </div>
                  ))}
                </div>
                {errors.CategoryType && <div className="invalid-feedback d-block">{errors.CategoryType}</div>}
              </div>

              {/* 4. Status */}
              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Status <span className="text-danger">*</span>
                </label>
                <select
                  className={`form-control ${errors.Description ? "is-invalid" : ""}`}
                  name="Status"
                  value={formData.Status}
                  onChange={handleChange}
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
                {errors.Status && <div className="invalid-feedback">{errors.Status}</div>}
              </div>

              {/* 3. Description */}

              <div className="col-md-12 mb-3">
                <label className="form-label">
                  Description
                </label>
                <textarea
                  className={`form-control ${errors.Description ? "is-invalid" : ""}`}
                  name="Description"
                  value={formData.Description}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-white border me-2"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onsubmit} disabled={isLoading}
            >
              {isLoading && <span className="spinner-border spinner-border-sm me-2" />}
              {modalType === "edit"
                ? "Edit Policy Category"
                : "Add Policy Category"}
            </button>
          </div>
        </form>
      </Drawer>

      <DeleteModal1
        isVisible={isDeleteModalVisible}
        onClose={() => setIsDeleteModalVisible(false)}
        onConfirm={() =>
          selectedRowData?.Id && handleDeletePolicy(selectedRowData.Id)
        }
      />

      {/* /Add Policy */}
    </>
  );
};

export default PolicyCategory;
